import type { DefaultTheme } from 'styled-components';

import { Status } from 'api/types/lead';
import { LeadGroups } from 'constants/leadGroups';

interface ILeadGroupColor {
    theme: DefaultTheme;
    type: LeadGroups;
}

export const leadGroupColor = ({ theme, type }: ILeadGroupColor): string => {
    switch (type) {
        case LeadGroups.RECOMMENDED:
            return theme.colors.recommended;
        case LeadGroups.CONTACTED:
            return theme.colors.contacted;
        case LeadGroups.ACTIVE_CONVERSATION:
        case LeadGroups.LISTED:
            return theme.colors.responded;
        case LeadGroups.CLOSED:
        case LeadGroups.SOLD:
        case LeadGroups.ARCHIVED:
            return theme.colors.closed;
        default:
            return theme.colors.recommended;
    }
};

interface ILeadStatusColor {
    theme: DefaultTheme;
    status: Status;
}

const LEAD_STATUS_GROUP_MAPPING = {
    [Status.RECOMMENDED]: LeadGroups.RECOMMENDED,
    [Status.NEW]: LeadGroups.RECOMMENDED,
    [Status.VIEWED]: LeadGroups.RECOMMENDED,
    [Status.CONTACTED]: LeadGroups.CONTACTED,
    [Status.CLOSED]: LeadGroups.CLOSED,
    [Status.DELETED]: LeadGroups.CLOSED,
    [Status.LISTED]: LeadGroups.LISTED,
    [Status.SOLD]: LeadGroups.SOLD,
    [Status.ACTIVE]: LeadGroups.ACTIVE_CONVERSATION,
    [Status.ARCHIVED]: LeadGroups.ARCHIVED,
    [Status.ALL]: LeadGroups.ARCHIVED,
};

export const leadStatusColor = ({
    theme,
    status,
}: ILeadStatusColor): string => {
    return leadGroupColor({
        theme,
        type: LEAD_STATUS_GROUP_MAPPING[status],
    });
};
